// extracted by mini-css-extract-plugin
var _1 = "LinkSection-module__columnedSection___dvtl7";
var _2 = "LinkSection-module__container___Bcuvw";
var _3 = "LinkSection-module__header___YHkBG";
var _4 = "LinkSection-module__link___nzgNW";
var _5 = "LinkSection-module__linksColumn___NgDfA";
var _6 = "LinkSection-module__listItem___CEreg";
export { _1 as "columnedSection", _2 as "container", _3 as "header", _4 as "link", _5 as "linksColumn", _6 as "listItem" }
